/*
 * Public API Surface of carousel
 */

export { NguCarouselConfig } from './lib/ngu-carousel/ngu-carousel';

export { NguCarouselStore } from './lib/ngu-carousel/ngu-carousel';

export { NguCarousel } from './lib/ngu-carousel/ngu-carousel.component';

export { NguCarouselModule } from './lib/ngu-carousel.module';

export { NguItemComponent } from './lib/ngu-item/ngu-item.component';

export { NguTileComponent } from './lib/ngu-tile/ngu-tile.component';

export {
  NguCarouselDefDirective,
  NguCarouselPointDirective,
  NguCarouselItemDirective,
  NguCarouselNextDirective,
  NguCarouselPrevDirective,
  NguCarouselOutlet
} from './lib/ngu-carousel.directive';
